import React, { useState } from 'react'
import { Col, Row, Button } from 'reactstrap'

//Componentes
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';

//Helpes
import { objCampo, validarCampos } from '../../../../helpers/ValidadorDeCampos';

//Contants
import { actionsTable } from '../../../../constants/MaterialTable';
import TextField from '../../../../components/TextField/TextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenAlt } from '@fortawesome/free-solid-svg-icons';

import uuid from '../../../../helpers/guid';
import { showQuestion } from 'helpers/message';

function initialStateBloco() {
  return {
    descricao: "",
    identificacao: "",
    hash: uuid(),
    deletado: false,
    sequencia: 0,
    tbFormularioPGRSBlocoQuestoes: []
  }
}

export default function Blocos({ formulario, setFormulario }) {
  const [bloco, setBloco] = useState(initialStateBloco());

  //Estado para pegar erros blocos
  const [errors, setErrors] = useState({});

  const campos = [
    objCampo({ name: "descricao", required: true }),
    objCampo({ name: "identificacao", required: true }),
    objCampo({ name: "sequencia", required: true, number: true }),
  ];

  //Cabeçalhos da tabela de bairros
  const headers = [
    { value: "Identificação", objectValue: "identificacao", align: "left" },
    { value: "Descrição", objectValue: "descricao", align: "left" },
    { value: "Sequência", objectValue: "sequencia", align: "left" },
  ];


  //Carrega os dados do bairro a ser editado no modal
  function editarBairro(item) {
    const _item = {...item}
    _item.sequencia = _item?.sequencia.toString()
    setBloco(_item)
  }

  function removerBloco(rowData, confirmacao) {
    if (!confirmacao) return;

    setFormulario({
      ...formulario,
      tbFormularioPGRSBlocos: [...formulario.tbFormularioPGRSBlocos.filter((item, index) => index != rowData.tableData.id)]
    })
  }

  const actions = [actionsTable.editar(editarBairro),
  actionsTable.remover((rowData) => {
    showQuestion(
      "Tem certeza disso?", "Você tem certeza de que deseja remover esta questão? Esta é uma ação irreversível",
      "warning",
      (confirmacao) => removerBloco(rowData, confirmacao)
    );
  })]

  function onChangeBloco(e) {
    const { name, value } = e.target;

    const _bloco = {
      ...bloco,
      [name]: value
    }

    const erros = validarCampos(_bloco, campos.filter(c => c.name == name));

    if (erros[1].length == 0) {
      const _errors = { ...errors };
      delete _errors[name];
      setErrors(_errors);
    }

    setBloco(_bloco);
  }

  function addBloco() {
    const erros = validarCampos(bloco, campos);
    setErrors(erros[0]);

    if (erros[1].length > 0) {
      return;
    }

    const _bloco = { ...bloco };
    let _formularioPGRSBlocos;

    if (_bloco.tableData) {
      _formularioPGRSBlocos = formulario.tbFormularioPGRSBlocos.filter(
        (bloco, index) => index != _bloco.tableData.id && bloco.hash != _bloco.hash
      );
      _formularioPGRSBlocos = [..._formularioPGRSBlocos, { ..._bloco }];
    } else
      _formularioPGRSBlocos = [...formulario.tbFormularioPGRSBlocos, { ..._bloco }];

    _formularioPGRSBlocos.sort((a, b) => (a.sequencia > b.sequencia ? 1 : -1));

    setFormulario({
      ...formulario,
      tbFormularioPGRSBlocos: _formularioPGRSBlocos,
    });

    setBloco(initialStateBloco());
  }


  return (
    <div className='p-2 m-2'>
      <Row>
        <Col md="12" lg="5">
          <TextField
            maxLength={"150"}
            label={"* Identificação"}
            name={"identificacao"}
            value={bloco.identificacao}
            onChange={onChangeBloco}
            invalid={!!errors.identificacao}
          />
        </Col>
        <Col md="12" lg="5">
          <TextField
            maxLength={"1500"}
            label={"* Descrição"}
            name={"descricao"}
            value={bloco.descricao}
            onChange={onChangeBloco}
            invalid={!!errors.descricao}
          />
        </Col>
        <Col md="12" lg="2">
          <TextField
            label={"* Sequência"}
            name={"sequencia"}
            type={"number"}
            value={bloco.sequencia}
            onChange={onChangeBloco}
            invalid={!!errors.sequencia}
          />
        </Col>
      </Row>
      <Row className='d-flex justify-content-center mb-4' >
        <Col  md="12" lg="2">
          <Button
            onClick={addBloco}
            color={bloco.tableData ? 'warning' : 'success'}
            className='w-100 mt-1 text-white'
          >
            {bloco.tableData ? <>
              <FontAwesomeIcon icon={faPenAlt} color='' /> Editar
            </> : "+ Adicionar"}
          </Button>
        </Col>
      </Row>
      <Row>
        <TabelaListagem
          options={{ print: false, search: true, pagination: true }}
          actions={actions}
          title='Lista de blocos'
          headers={headers}
          items={formulario?.tbFormularioPGRSBlocos ?? []}
        />
      </Row>
    </div>
  )
}
